import { FaTrash, FaFilter, FaEye, FaCloudDownloadAlt, FaCheck, FaCheckDouble, FaBan, FaCopy } from 'react-icons/fa';

export default {
  bulkDelete: {
    icon: FaTrash,
    title: 'Bulk delete items',
  },
  clone: {
    icon: FaCopy,
    title: 'Clone item',
  },
  delete: {
    icon: FaTrash,
    title: 'Delete item',
  },
  bulkFilter: {
    icon: FaFilter,
    title: 'Filter columns',
  },
  filter: {
    icon: FaFilter,
    title: 'Filter',
  },
  view: {
    icon: FaEye,
    title: 'View',
  },
  download: {
    icon: FaCloudDownloadAlt,
    title: 'Download',
  },
  approve: {
    icon: FaCheck,
    title: 'Approve',
  },
  bulkApprove: {
    icon: FaCheckDouble,
    title: 'Bulk approve',
  },
  deny: {
    icon: FaBan,
    title: 'Deny',
  },
  bulkDeny: {
    icon: FaBan,
    title: 'Bulk deny',
  },
};
